import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
	name: "sanitize",
	standalone: false
})
export class SanitizerPipe implements PipeTransform {

	constructor(private $sanitizer: DomSanitizer) { }

	transform = (url: string, fn: string = "ResourceUrl"): any => this.$sanitizer[`bypassSecurityTrust${fn}`](url);
}